import reduce from 'lodash-es/reduce';
import findIndex from 'lodash-es/findIndex';

import { PriceDistributionTrimPercentage } from 'ha/pages/Search/constants';

import reformatPriceDistribution, {
  DistributionValue,
} from './reformatPriceDistribution';
import getPriceDistribution, {
  PriceDistributionArgs,
} from './getPriceDistribution';

export default ({
  pricesFacet,
  minPrice,
  maxPrice,
  rate,
}: PriceDistributionArgs) => {
  const priceDistribution: DistributionValue[] = reformatPriceDistribution(
    getPriceDistribution({
      pricesFacet,
      minPrice,
      maxPrice,
      rate,
    }),
  );

  // Get value for last included range (limit).
  const limitValue =
    (1 - PriceDistributionTrimPercentage / 100) *
    reduce(priceDistribution, (a, b) => a + b.value, 0);

  let accumValue = 0;
  // Get first index of value that covers the limit.
  const limitIndex = findIndex(priceDistribution, bucket => {
    accumValue += bucket.value;

    return accumValue >= limitValue;
  });
  const nextIndex =
    limitIndex + 1 < priceDistribution.length ? limitIndex + 1 : limitIndex;

  const trimmedPriceMin = minPrice;
  const trimmedPriceMax = priceDistribution[nextIndex].range;

  return getPriceDistribution({
    pricesFacet,
    minPrice: trimmedPriceMin,
    maxPrice: trimmedPriceMax,
    rate,
  });
};
